
<div class="full-size-container">

<!--  Put here wraper for center holder of top -->

  <div class="page-container">

  @if (!isOnline) {
  <div class="offline-info">
    <mat-icon class="offline-icon">wifi_off</mat-icon>
    <div class="offline-text">Brak połączenia z internetem.<br>Niektóre funkcje nie będą dostępne. Dane załadowane
      wcześniej będą prezentowane w trybie offline.</div>
  </div>
  }

  <!-- Loading Spinner -->
  @if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Ładowanie...</p>
  </div>
  }



  @if (true || !isLoggedIn && showIntro) {
  <div class="home-info">
    <div class="intro-text">
      <h2 class="title">Co zyskujesz?</h2>
      <p>Coś na ząb? Sportowe popołudnie? Kulturalny weekend? Zakupy ze zniżką? Znajdź, czego potrzebujesz wśród ofert
        naszych Partnerów i ciesz się z bycia wśród ZGranych Zielonogórzan!</p>
      @if (false) {
      <div class="offer-search-form">
        <form class="search-offer-form" (ngSubmit)="onSearchOffer()">
          <input type="text" matInput [(ngModel)]="offerSeearch" placeholder="Szukaj oferty..." />

          <button class="custom-button" (click)="onSearchOffer()">Szukaj</button>
        </form>
      </div>
      }
      <div class="offer-category-holder">
        <app-offer-menu [emitOnStart]="false" (groupSelected)="onGroupSelected($event)"></app-offer-menu>
      </div>
    </div>
    <div class="intro-img">
      <img [src]="'assets/home_2.png'"
        alt="Ilustracja przedstawiająca program Zgrane Grono - rodziny korzystające z programu lojalnościowego" />
    </div>
  </div>
  }

  <!-- Banners Carousel - Show for all users when online -->
  @if (showBanners && banners && banners.length > 1) {
  <div class="banners-holder">
    <div class="banners-carousel" #bannersCarousel>
      <button tabindex="45" class="carousel-nav carousel-prev" (click)="previousBanner()"
        [disabled]="currentBannerIndex === 0">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="carousel-container" [style.transform]="'translateX(-' + (currentBannerIndex * 100) + '%)'">
        @for (banner of banners; track banner; let i = $index) {
        <div class="banner-slide" [class.active]="i === currentBannerIndex" (click)="goToBannerLink(banner)"
          [attr.aria-label]="banner.title">
          <img [src]="imageRoot + '/banners/' + banner.file" [alt]="banner.title" class="banner-image"><!--
                  <div class="banner-overlay" *ngIf="banner.title">
                    <h3 class="banner-title">{{ banner.title }}</h3>
                  </div>-->
        </div>
        }
      </div>
      <button tabindex="46" class="carousel-nav carousel-next" (click)="nextBanner()"
        [disabled]="currentBannerIndex === banners.length - 1">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <div class="carousel-indicators">
        @for (banner of banners; track banner; let i = $index) {
        <button tabindex="47 + i" class="indicator" [class.active]="i === currentBannerIndex" (click)="goToBanner(i)"
          [attr.aria-label]="'Przejdź do bannera ' + (i + 1)">
        </button>
        }
      </div>
    </div>
  </div>
  }
  <!-- Single Banner - Show for all users when online -->
  @if (showBanners && banners && banners.length === 1) {
  <div class="single-banner-holder">
    <div class="single-banner" (click)="goToBannerLink(banners[0])" tabindex="47" [attr.aria-label]="banners[0].title">
      <img [src]="imageRoot + '/banners/' + banners[0].file" [alt]="banners[0].title" class="banner-image">
    </div>
  </div>
  }




  @if (!loading && showOffers && topOffers && topOffers.length > 0) {
  <div class="tails-holder">
    <div class="box-title offers">{{ customOffersTitle }}</div>
    @for (offer of topOffers; track offer; let i = $index) {
    <app-offer-view class="offer-item" (click)="goToOfferDetails(offer)" [offer]="offer"
      tabindex="80 + i"></app-offer-view>
    }
  </div>
  }


  @if (!loading && showPartners && lastPartners && lastPartners.length > 0) {
  <div class="tails-holder">
    <div class="box-title offers">{{ customPartnersTitle }}</div>
    @for (partner of lastPartners; track partner; let i = $index) {
    <app-partnerspartner-view tabindex="100 + i" [partner]="partner" class="partner-item"
      (click)="goToPartnerDetails(partner)" [partner]="partner">
    </app-partnerspartner-view>
    }
  </div>
  }

  @if (!loading && showNews && topNews && topNews.length > 0) {
  <div class="news-holder" [class.few-items]="topNews.length < 3">
    <div class="box-title offers">{{ customNewsTitle }}</div>
    @for (news of topNews; track news; let i = $index) {
    <app-news-list-item (click)="goToNewsDetails(news)" tabindex="60 + i" [news]="news" [homeView]="true"
      class="news-item">
    </app-news-list-item>
    }
  </div>
  }

</div>
</div>